import * as React from "react";
import { ODataParams, Query } from "../../Components/Query";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { PopulationGroupsTable } from "./PopulationGroupsTable";
import { useParams } from "react-router-dom";
import { useCookieRedirect } from "../../misc/CookieRedirect";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const PopulationGroupsList = () => {
    const { id } = useParams<{ id: string }>();
    const client = useWebPortalApiClient();

    useCookieRedirect(id);

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : "";
        filter += `studyId eq ${id}`;

        return await client.client.getPopulationGroups(undefined, filter, params.orderby, undefined, params.top, params.skip);
    };

    return (
        <DocumentTitle title="Population Groups | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "name", condition: "asc" }]}>
                <PopulationGroupsTable />
            </Query>
        </DocumentTitle>
    );
};
